/**
 * The open-questions panel asks one question at a time. These helpers decide which one is next.
 * "Seen" means the person has answered it or chosen "Skip for now" during this visit; an explicit
 * "I don't know" stays an open question (clocks may be waiting) but is not asked again straight away.
 */
export function nextUnseen<T extends { id: string }>(open: readonly T[], seen: readonly string[]): T | null {
  return open.find((q) => !seen.includes(q.id)) ?? null
}
